import Image from "next/image";
import { useEffect } from "react";
import { Text } from "ui-components";

import { TRAINING_FOLDER_THUMBNAIL } from "@/src/constants/images";
import { useOrganizationSharedFileGetTrainingEvents } from "@/src/hooks/api/generated";

interface ITrainingInterface {
  category: { name: string };
  onSelectCategory?: (category: { name: string }) => void;
}

export function TrainingItem({
  category,
  onSelectCategory,
}: ITrainingInterface): JSX.Element {
  const { mutate: fetchTrainingEvents, data: trainingResponse } =
    useOrganizationSharedFileGetTrainingEvents();

  useEffect(() => {
    fetchTrainingEvents({ data: { page: 1, pageSize: 1 } });
  }, [fetchTrainingEvents]);

  const handleClick = (): void => {
    if (onSelectCategory) {
      onSelectCategory(category);
    }
  };
  return (
    <div
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      tabIndex={0}
      className="w-full pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-4 overflow-hidden"
    >
      <div className="inline-flex justify-center items-center gap-2.5 overflow-hidden">
        <Image
          src={TRAINING_FOLDER_THUMBNAIL}
          alt="illustration"
          width={640}
          height={128}
          unoptimized
        />
      </div>
      <div className="self-stretch px-4 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch inline-flex justify-between items-center">
          <Text variant="large" className="text-lg">
            {category.name}
          </Text>
        </div>
        <div className="self-stretch justify-start text-neutral-600 text-sm font-medium">
          {trainingResponse ? `${trainingResponse.total} videos` : " "}
        </div>
      </div>
    </div>
  );
}
